const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/contributors/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import i18n from '@/lib/translations/i18n';
import { ensureNamespaceLoaded } from '@/lib/translations/i18nloader';
import type { LoaderData } from '@/lib/types/common';
export const Route = createFileRoute('/(app)/org/$org/contributors')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: async () => {
    await ensureNamespaceLoaded('contributors');
  },
  loader: (): LoaderData => ({
    crumb: i18n.t('contributors.route.title')
  }),
  pendingComponent: FullSizeSpinner,
  staticData: {
    topNav: {
      title: i18n.t('contributors.route.title')
    }
  }
});